import { Injectable } from '@zhfe/vue2-di-plugin'
import { UserService } from './user.service'
import { SDK_PRODUCT, REPORT_PARAMS } from '@/config/dataMap'
import client from '@/client/modules/common'
import Cookie from 'js-cookie'

interface SystemInfo {
  /** 系统 */
  os?: string,
  /** 系统名 */
  name?: string,
  /** 结果 */
  result?: string | number
}

@Injectable()
export class CustomerService {
  constructor (private user: UserService) {

  }

  /** 联系客服链接 */
  async getContactCustomerServiceUrl (type: 'vip-center' | 'pdf-enterprise' | 'pdf-transition'| 'web-pdf') {
    if (!type) {
      throw new Error('请传入类型。可选类型：vip-center、pdf-enterprise、pdf-transition、web-pdf')
    }

    const url = this.getServiceUrl(type)
    const { tid1 = 0, tid2 = 0, tod1 = 0, tod2 = 0 } = (window as any).app.$TidObj
    const tryno = Cookie.get('tryno') || ''
    const systemVersio = await this.getSystemVersion()
    const clientMajorVersion = await this.getClientMajorVersion()

    const qidian_ex1 = [this.user.openId || 0, SDK_PRODUCT.id].join(';')
    const qidian_ex2 = [REPORT_PARAMS.user_svrid, tid1, tid2, tod1, tod2].join(';')
    const qidian_ex3 = [clientMajorVersion, tryno, systemVersio].join(';')

    return `${url}&qidian_ex1=${qidian_ex1}&qidian_ex2=${qidian_ex2}&qidian_ex3=${qidian_ex3}&wpaShowItemId=1`
  }

  /** 客服链接 */
  getServiceUrl (type):string {
    const urlMap = {
      /** 会员中心： */
      'vip-center': 'https://wpa1.qq.com/MWrjWSv6?_type=wpa&qidian=true',
      /** 会员中心（企业版）  */
      'pdf-enterprise': 'https://wpa1.qq.com/lC7JLkZw?_type=wpa&qidian=true',
      /** PDF转换： */
      'pdf-transition': 'https://wpa1.qq.com/yyEqq6qR?_type=wpa&qidian=true',
      /** 网页版PDF： */
      'web-pdf': 'https://wpa1.qq.com/KEH9xErf?_type=wpa&qidian=true',
    }
    return urlMap[type]
  }

  /** 系统版本号 */
  async getSystemVersion () {
    try {
      const { os = '0' }: SystemInfo = await this.checkClientMethod('getPCInfo') && await client.API.client_get_device_info()
      return os
    } catch (e) {
      return '0'
    }
  }

  /** 客户端主版本号 */
  async getClientMajorVersion () {
    try {
      const { pdfVersion = '0' }: { pdfVersion: string } = await this.checkClientMethod('getReaderVersion') && await client.API.client_major_version()
      return pdfVersion
    } catch (e) {
      return '0'
    }
  }

  /**
   * 检查当前客户端是否支持该方法
   * @param {string} fname | 方法名
   */
  async checkClientMethod (fname:string) {
    const hasMethod = await client.API.client_checkMethod(fname)
    return hasMethod && hasMethod.result
  }
}
